import { useEffect, useState } from "react";
import { Button, Checkbox, Form, Icon, Input } from "semantic-ui-react";

import InputComponents from "../../components/InputComponents/InputComponents";
import { useDispatch } from "react-redux";
import { loading, loadingDestroy, notice } from "../../redux/action/action";
import { useNavigate } from "react-router";
import GetParams from "../../utils/getParams";
import { useTranslation } from "react-i18next";
import { appName } from "../../config";
import { getVerifyCode } from "../../api/getApi";
import {
  actionSignIn,
  actionSignUp,
  verifiedRobotBoy,
} from "../../api/postApi";
import {
  passwordExpressForInput,
  phoneExpressForInput,
} from "../../regex_constanst";
import Cookies from "js-cookie";
import { InitializeApi } from "../../api/initializeApi";
import ReCAPTCHA from "react-google-recaptcha";
import Term from "./components/term";
import { set } from "date-fns";
import useGetAgentName from "../../hook/useGetAgentName";
import CustomTurnstile from "../Singin/components/customTurnstile";
import RegisterAgent from "../Singin/components/registerAgent";
import useCookiesAgentName from "../Singin/components/useCookiesAgentName";

const MailSignup = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`header.${key}`, { ...props });
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_common_form = (key) => t(`settings.form.${key}`);
  const i18n_formHint = (key, props) => t(`formHint.${key}`, { ...props });
  const i18n_backend_response = (key) => t(`backend_response.${key}`);

  const referCodeParams = GetParams("refer_code");

  const [watchPassword, setWatchPassword] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [data, setData] = useState({
    referCode: referCodeParams,
    isReadTerms: false,
    isNotRobot: false,
  });
  const {
    userName,
    password,
    mobile,
    userRealName,
    messageapp,
    email,
    auth_num,
    referCode,
  } = data;
  const [dataFocus, setDataFocus] = useState({});
  const [showBonus, setShowBonus] = useState(false);
  const [verifyCode, setVerifyCode] = useState("");
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const [isVerify, setIsVerify] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const agentName = useGetAgentName();
  const cookiesFromAgent = useCookiesAgentName();

  useEffect((value) => {
    getVerifyCode().then((data) => {
      setVerifyCode(data.url);
    });
  }, []);

  const handleSignup = (recaptchaResponse) => {
    // dispatch(loading());
    setButtonLoading(true);
    verifiedRobotBoy(recaptchaResponse);

    actionSignUp({
      memId: userName,
      passwd: password,
      blank_name: userRealName,
      mobile: mobile,
      email: email,
      messageapp: messageapp || "zalo",
      auth_num: auth_num,
      unlimit_code: referCode,
      invite: cookiesFromAgent,
    })
      .then((data) => {
        dispatch(notice(i18n_backend_response("Sign up success"), "success"));
        setTimeout(() => {
          actionSignIn({
            account: userName,
            passwd: password,
          }).then((data) => {
            dispatch(notice(i18n_backend_response(data.message), "success"));
            if (Cookies.get("token")) {
              Cookies.remove("token");
            }
            Cookies.set("token", data.token, { expires: 3 });

            dispatch({
              type: "INITIALIZE_API",
              navigate: navigate,
              tmpToken: data.tmpToken,
            });

            navigate("/casino");
          });
        }, 1500);
      })
      .catch((err) => {})
      .finally(() => {
        setButtonLoading(false);
      });
  };

  const inputList = [
    {
      label: i18n_common_form("account"),
      name: "userName",
      type: "text",
      required: true,
      onChange: (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
      },
      onFocus: (e) => setDataFocus({ [e.target.name]: true }),
    },
    {
      label: i18n_common_form("password"),
      name: "password",
      type: watchPassword ? "text" : "password",
      needIcon: true,
      required: true,
      icon1: watchPassword ? "eye slash" : "eye",
      pattern: passwordExpressForInput,
      placeholder: i18n_formHint("includeEightEnglishAndNumber"),
      title: i18n_formHint("includeEightEnglishAndNumber"),
      function: () => setWatchPassword(!watchPassword),
      onChange: (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
      },
      onFocus: (e) => setDataFocus({ [e.target.name]: true }),
    },
    {
      label: i18n_common_form("realName"),
      name: "userRealName",
      type: "text",
      required: true,
      onChange: (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
      },
      onFocus: (e) => setDataFocus({ [e.target.name]: true }),
    },
    {
      label: i18n_common_form("email"),
      name: "email",
      type: "text",
      onChange: (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
      },
      onFocus: (e) => setDataFocus({ [e.target.name]: true }),
    },
  ];

  return (
    <>
      <section>
        <Form onSubmit={handleSignup}>
          {inputList.map((input, index) => {
            return (
              <>
                <label className="text-base text-sm text-base-dark dark:text-base-light-white">
                  {input.label}
                  {input.required && <span className="text-red-500">*</span>}
                </label>
                <InputComponents
                  focusProps={dataFocus}
                  dataProps={data}
                  setDataProps={setData}
                  inputProps={input}
                  index={index}
                  placeholder={input.placeholder}
                  title={input.title}
                  onFocus={(e) => setDataFocus({ [e.target.name]: true })}
                  className="!p-[12px]"
                />
              </>
            );
          })}
          <label className="text-base text-sm text-base-dark dark:text-base-light-white">
            {i18n_common_form("communityAccount")}
            <span className="text-red-500">*</span>
          </label>
          <div className="flex items-start gap-[10px]">
            <p
              name="messageapp"
              className="!w-[100px] !shadow bg-base-light-white dark:!bg-base-light-black border dark:border-base-light-dark rounded-[5px] text-base-light-dark dark:text-base-light-white py-[11px] px-[11px] !rounded-[5px]  border "
            >
              Zalo
            </p>
            <InputComponents
              dataProps={data}
              setDataProps={setData}
              focusProps={dataFocus}
              onFocus={(e) => setDataFocus({ [e.target.name]: true })}
              inputProps={{
                label: i18n_common_form("mobile"),
                name: "mobile",
                type: "text",
                onChange: (e) => {
                  setData({ ...data, [e.target.name]: e.target.value });
                },
                pattern: phoneExpressForInput,
                title: i18n_common_form("phoneNumber"),
                required: true,
              }}
              className="!p-[12px]"
            />
          </div>
          {/* <>
          <label className="text-base text-sm text-base-dark dark:text-base-light-white">
            {i18n("signup_page.auth")}
          </label>
          <div className="flex items-start gap-[10px]">
            <InputComponents
              dataProps={data}
              setDataProps={setData}
              focusProps={dataFocus}
              onFocus={(e) => setDataFocus({ [e.target.name]: true })}
              inputProps={{
                label: i18n("signup_page.auth"),
                name: "auth_num",
                type: "text",
                onChange: (e) => {
                  setData({ ...data, [e.target.name]: e.target.value });
                },
              }}
              className="!p-[12px]"
            />
            <img
              src={`data:image/png;base64,${verifyCode}`}
              className="w-[250px] h-[38px]"
            />
          </div>
        </> */}

          {referCode && (
            <div>
              <label className="text-base text-sm text-base-dark dark:text-base-light-white">
                <span
                  onClick={() => {
                    setShowBonus(true);
                  }}
                  className="underline hover:text-main-color text-base-dark dark:text-base-light-white cursor-pointer"
                >
                  {i18n_common_form("invitedCode")}
                </span>
                ({i18n("signup_page.ifYouHaveInvited")})
              </label>
              <InputComponents
                dataProps={data}
                setDataProps={setData}
                focusProps={dataFocus}
                onFocus={(e) => setDataFocus({ [e.target.name]: true })}
                inputProps={{
                  label: i18n_common_form("invitedCode"),
                  name: "referCode",
                  type: "text",
                  onChange: (e) => {
                    setData({ ...data, [e.target.name]: e.target.value });
                  },
                  disabled: true,
                }}
                className="!p-[12px]"
              />
            </div>
          )}
          <RegisterAgent />
          <CustomTurnstile setIsVerify={setIsVerify} />

          <Checkbox
            name="isReadTerms"
            checked={data.isReadTerms}
            onChange={() => {
              setData({ ...data, isReadTerms: !data.isReadTerms });
            }}
            label={{
              children: (
                <p className="text-base text-sm text-base-dark dark:text-base-light-white">
                  {i18n_common("iReadAndAgree")}
                  <span
                    onClick={() => {
                      setOpenTermsModal(true);
                    }}
                    className="text-main-color"
                  >
                    {i18n_common("termsAndConditions")}
                  </span>
                </p>
              ),
            }}
          />
          <Button
            type="submit"
            disabled={buttonLoading || !data.isReadTerms || !isVerify}
            loading={buttonLoading}
            size="xl"
            id="signup-button"
            className="w-full !bg-main-color hover:bg-hover-main-color !mt-[30px] !text-white !py-[16px]"
          >
            {i18n("signup")}
          </Button>
        </Form>
        <p className="text-transaction-text dark:text-light-white text-sm font-light mt-[20px]">
          {i18n("signup_page.signupHint", { casino: appName })}
        </p>
      </section>
      {openTermsModal && <Term setOpenTermsModal={setOpenTermsModal} />}
    </>
  );
};

export default MailSignup;
